import {
  convertEventSelectToTarget,
  FormFeedBack,
  ModalBase,
  Select,
  STATUSPAGE,
} from '@repo/ui';
import { FormikValues } from 'formik';
import { useRef } from 'react';
import { Row, Col, Form, Label, Input } from 'reactstrap';

interface ModalBannerFormProps {
  isOpen: boolean;
  formik: FormikValues;
  imagePreview?: string;
  isLoading?: STATUSPAGE;
  courseOptions: Array<{ label: string; value: string }>;
  toggle: () => void;
  handleClose: () => void;
  handleImageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ModalBannerForm = ({
  isOpen,
  formik,
  isLoading,
  imagePreview,
  courseOptions,
  handleClose,
  handleImageChange,
}: ModalBannerFormProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <ModalBase.Wrapper
      isOpen={isOpen}
      toggle={handleClose}
      size="lg"
      loading={false}
    >
      <ModalBase.Header toggle={handleClose} withBorderBottom>
        Nova Publicidade
      </ModalBase.Header>

      <Form
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
          return false;
        }}
      >
        <ModalBase.Body>
          <Row className="g-3">
            <Col md={12}>
              <Label htmlFor="photo" className="form-label">
                Imagem do Banner <span className="text-danger">*</span>
              </Label>
              <Input
                id="photo"
                type="file"
                name="photo"
                innerRef={fileInputRef}
                onChange={handleImageChange}
                accept="image/png, image/jpeg, image/jpg"
              />
              <FormFeedBack
                error={formik.errors.photo as string}
                isInvalid={formik.touched.photo && !!formik.errors.photo}
              />
              <small className="text-muted">
                Formatos aceitos: PNG, JPG, JPEG (máx. 5MB)
              </small>
            </Col>

            {imagePreview && (
              <Col md={12}>
                <div className="border rounded p-2 text-center">
                  <img
                    src={imagePreview}
                    alt="Preview"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '200px',
                      objectFit: 'contain',
                    }}
                  />
                </div>
              </Col>
            )}

            <Col md={12}>
              <Label htmlFor="link" className="form-label">
                Link de Redirecionamento <span className="text-danger">*</span>
              </Label>
              <Input
                id="link"
                type="url"
                name="linkUrl"
                placeholder="https://exemplo.com"
                value={formik.values.linkUrl}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={formik.touched.linkUrl && !!formik.errors.linkUrl}
              />
              <FormFeedBack
                error={formik.errors.linkUrl as string}
                isInvalid={formik.touched.linkUrl && !!formik.errors.linkUrl}
              />
            </Col>

            <Col md={12}>
              <Label htmlFor="courseId" className="form-label">
                Curso <span className="text-danger">*</span>
              </Label>
              <Select
                isMulti
                id="courseIds"
                name="courseIds"
                options={courseOptions}
                value={formik.values.courseIds}
                placeholder="Selecione os cursos"
                onChange={(value) => {
                  formik.handleChange(
                    convertEventSelectToTarget('courseIds', value)
                  );
                }}
                onBlur={formik.handleBlur}
                invalid={formik.touched.courseIds && !!formik.errors.courseIds}
              />
              <FormFeedBack
                error={formik.errors.courseIds as string}
                isInvalid={
                  formik.touched.courseIds && !!formik.errors.courseIds
                }
              />
            </Col>

            <Col md={6}>
              <div className="form-check form-switch form-switch-lg">
                <Input
                  role="switch"
                  type="checkbox"
                  id="showInStudentApp"
                  name="showInStudentApp"
                  className="form-check-input"
                  onChange={formik.handleChange}
                  checked={formik.values.showInStudentApp}
                />
                <Label className="form-check-label" htmlFor="showInStudentApp">
                  Exibir no App do Estudante
                </Label>
              </div>
            </Col>

            <Col md={6}>
              <div className="form-check form-switch form-switch-lg">
                <Input
                  role="switch"
                  type="checkbox"
                  id="showInProfessionalApp"
                  name="showInProfessionalApp"
                  className="form-check-input"
                  onChange={formik.handleChange}
                  checked={formik.values.showInProfessionalApp}
                />
                <Label
                  className="form-check-label"
                  htmlFor="showInProfessionalApp"
                >
                  Exibir no App do Profissional
                </Label>
              </div>
            </Col>
          </Row>
        </ModalBase.Body>

        <ModalBase.Footer>
          <ModalBase.Actions
            goBack={handleClose}
            actionBtnType="submit"
            loading={isLoading === STATUSPAGE.LOADING}
          />
        </ModalBase.Footer>
      </Form>
    </ModalBase.Wrapper>
  );
};
